export enum RegexMapOptions {
    AmountCharsOnly = 'amountCharsOnly',
    numberOnly = 'numberOnly',
    englishOnly = 'englishOnly',
    positiveAmount = 'positiveAmount',
    amountCharsOnlyWith2DecimalMax = 'amountCharsOnlyWith2DecimalMax',
    phoneNumber = 'phoneNumber',
    durationIndicator = 'durationIndicator',
}

export type ISize = 'small' | 'medium';

export type IColors =
    | 'primary'
    | 'error'
    | 'inherit'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning';

export interface IOption {
    label: string;
    value: string;
    key?: string;
    disabled?: boolean;
    tooltipText?: string;
    iconUrl?: string;
}

export interface ExtendFile extends File {
    preview?: string;
    path?: string;
    lastModifiedDate?: string;
}

export type FileInputValue = string | number | null;
